import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { LoginService } from 'src/app/services/login/login.service';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-user-history',
  templateUrl: './user-history.page.html',
  styleUrls: ['./user-history.page.scss'],
})
export class UserHistoryPage implements OnInit {
  userID;
  orders;

  constructor(
    private menu: MenuController,
    private router: Router,
    private auth: AngularFireAuth,
    private orderService: OrderService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.userID = user.uid;
        this.orderService.getUserOrders(this.userID).subscribe((res) => {
          this.orders = res.map((order) => order.payload.doc.data());
          this.orders = this.orders
            .sort((a, b) => b.createdAt - a.createdAt)
            .filter((a) => a.status === 'delivered');
        });
      } else {
        this.router.navigate(['/home/login']);
      }
    });
  }

  openUserMenu(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  userProfile() {
    this.router.navigate(['user-home']);
  }
  cashier() {
    this.router.navigate(['user-cashier']);
  }
  userUpdate() {
    this.router.navigate(['user-update']);
  }
  userHist() {
    this.router.navigate(['user-history']);
  }
  userOrders() {
    this.router.navigate(['user-orders']);
  }

  logout() {
    this.loginService.logout();
  }
}
